import { FormattingRule } from '@ardoq/data-model';
import { APIEntityType } from '@ardoq/api-types';
import type { I18nLocale } from '@ardoq/i18n';
import { FormattingRuleRowByTag } from './FormattingRuleRowByTag';
import { FormattingRuleRowByComponentOrReference } from './FormattingRuleRowByComponentOrReference';

type EntityFormattingRuleProperties = {
  formattingRule: FormattingRule;
  dragAndDropCardId: string;
  colorPaletteAlignment: 'left' | 'right';
  i18nLocale?: I18nLocale;
};
export const EntityFormattingRule = ({
  formattingRule,
  colorPaletteAlignment,
  i18nLocale,
}: EntityFormattingRuleProperties) => {
  if (formattingRule.type === APIEntityType.TAG) {
    return (
      <FormattingRuleRowByTag
        formattingRule={formattingRule}
        colorPaletteAlignment={colorPaletteAlignment}
        i18nLocale={i18nLocale}
      />
    );
  }
  return (
    <FormattingRuleRowByComponentOrReference
      formattingRule={formattingRule}
      colorPaletteAlignment={colorPaletteAlignment}
      i18nLocale={i18nLocale}
    />
  );
};
